




































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import TextField from './TextField.vue';
import {DateTime} from 'luxon';

@Component({
  components: {TextField},
})
export default class DateTimePicker extends Vue {
  @Prop() dateTimeValue!: number | null;
  @Prop() activatorAttrs!: any;
  @Prop() pickerAttrs!: any;
  @Prop({default: false, type: Boolean}) nullable!: boolean;
  @Prop() label!: string;
  @Prop({type: Boolean, default: false}) readonly!: boolean;
  @Prop() min!: number | undefined;
  @Prop({default: false, type: Boolean}) hideTimeTab!: boolean;

  private menu = false;

  dataPickerValue = '';
  timeValue = '';

  tabDate = 'tabDate';
  tabTime = 'tabTime';

  tab = this.tabDate;

  @Watch('menu')
  changeStatusMenu(isShow: boolean) {
    if (isShow) {
      this.dataPickerValue = this.dateTimeValue
        ? DateTime.fromMillis(this.dateTimeValue).toISODate()
        : '';

      if (this.dateTimeValue) {
        const date = DateTime.fromMillis(this.dateTimeValue);
        let hours: any = date.hour;
        let minutes: any = date.minute;
        if (hours < 10) hours = '0' + hours;
        if (minutes < 10) minutes = '0' + minutes;
        this.timeValue = `${hours}:${minutes}`;
      }
    } else {
      this.tab = 'tabDate';
    }
  }

  get textValue() {
    const defaultDateOptions = this.hideTimeTab
      ? {locale: 'ru-RU', year: 'numeric', month: '2-digit', day: '2-digit'}
      : {
          locale: 'ru-RU',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
        };
    if (this.dateTimeValue !== null)
      return DateTime.fromMillis(this.dateTimeValue).toLocaleString(defaultDateOptions);
    return this.dateTimeValue;
  }

  setTime(millsec: number, time: string): number {
    // time format is 'hh:mm'
    const hours = +time.substr(0, 2);
    const minutes = +time.substr(3);
    const date = DateTime.fromMillis(millsec).toLocal();
    const fullDateTime = DateTime.local(date.year, date.month, date.day, hours, minutes);
    return fullDateTime.valueOf();
  }

  get disableDates() {
    const dateToday = DateTime.local().valueOf();
    return DateTime.fromMillis(dateToday).toISODate();
  }

  get enableDates() {
    if (!this.min) return undefined;
    return DateTime.fromMillis(this.min).toISODate();
  }

  onClear() {
    this.$emit('input', null);
  }

  submit() {
    let date =
      this.dataPickerValue === null
        ? this.dataPickerValue
        : DateTime.fromISO(this.dataPickerValue).toMillis();
    if (date && this.timeValue) date = this.setTime(date, this.timeValue);
    this.$emit('setDate', date);
    this.menu = false;
  }
}
